import getLoadingStatus from './loading-status';

export default {
  getLoadingStatus,
};
